// One place that decides whether a data request may be submitted, and why not. Pages show the
// returned text next to the Submit button instead of calling alert() or letting the backend 400.
// Pure: no React, router or Firebase imports.
import type { TimeWindow } from './dateWindow';

/** The slice of useDataWindow's state the guard reads. Structural, so utils stay below hooks. */
export interface SubmitGuardWindow {
  /** DataWindowStatus; only 'ready' lets a request through. */
  status: string;
  reason: string | null;
  window: TimeWindow | null;
}

/** null = go ahead; otherwise the reason to show. Never returns an empty string. */
export function submitBlockReason(a: {
  dw: SubmitGuardWindow;
  selectionCount: number;
  /** A page-specific reason (for example an invalid threshold), checked last. */
  extra?: string | null;
}): string | null {
  // While the delivery days load there is no reason yet; say so instead of calling them unavailable.
  if (a.dw.status === 'loading') return 'Loading delivery days…';
  if (a.dw.status !== 'ready') return a.dw.reason || 'Delivery days are not available';
  if (!a.dw.window) return 'Pick a delivery day';
  if (!(a.selectionCount > 0)) return 'Select at least one area';
  return a.extra || null;
}
